import React from 'react';
import { BenefitsItem } from '../BenefitsItem';

import './styles.scss';

// eslint-disable-next-line react/prop-types
export const Benefits = ({ content = [] }) => (
    <div className="page-container">
        <div className={`grid-list-view ${content.length > 3 ? 'half-image-size' : ''}`}>
            {content.map((item, index) => (
                <BenefitsItem key={index} {...item} />
            ))}
        </div>
    </div>
);
